import { cleanupDropZone, initDropZone } from 'util/drop_zone'

import { MEDIA_QUERIES, css } from 'design'
import React, { useCallback, useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Room from '../../components/calls/room'
import { WidgetHeaderBar } from '../../components/live_chat_widget/widget_header_bar'
import { LightboxProvider } from '../../components/timelines/lightbox'
import Timelines from '../../components/timelines/timelines'
import { Composer } from '../../components/topics/composer/composer'
import ErrorBoundary from '../../containers/error_boundary/error_boundary'
import { useCallManager } from '../../contexts/call_manager_context'
import usePreviousProps from '../../hooks/previous_props_hook'
import { useAxios } from '../../hooks/use_axios'
import { useMediaQuery } from '../../hooks/use_media_query'
import { getSelectedTopicId } from '../../reduxes/slices/selected/selectors'
import { fetchFiles as fetchFilesAction } from '../../reduxes/slices/topics/actions'
import { AppLocationContext, TOPIC_VIEW } from '../admin/app_location_provider'
import { WidgetPageContainer } from './widget_page_container'

export const TopicPage = () => {
  const selectedTopicId = useSelector(getSelectedTopicId)
  const {
    activeCall: { isOnCall, navToVideoView },
  } = useCallManager()
  const prevIsOnCall = usePreviousProps(isOnCall)

  const { appLocation } = useContext(AppLocationContext)
  const mediumBp = useMediaQuery(MEDIA_QUERIES.md)
  const dispatch = useDispatch()
  const axios = useAxios()

  useEffect(() => {
    initDropZone()
    return () => {
      cleanupDropZone()
    }
  }, [])

  const fetchFiles = useCallback(() => {
    if (!selectedTopicId) {
      return
    }

    // eslint-disable-next-line
    // @ts-ignore
    dispatch(axios(fetchFilesAction(selectedTopicId))).catch((e) =>
      ErrorBoundary.logErrorToMyService(e),
    )
  }, [axios, dispatch, selectedTopicId])

  useEffect(() => {
    fetchFiles()
  }, [fetchFiles])

  // If the user triggers a call on mobile, navigate directly to the Call view
  // This is specifically to reduce the jarring effect of starting a call on mobile
  useEffect(() => {
    if (mediumBp) {
      return
    }

    if (prevIsOnCall === false && isOnCall && navToVideoView) {
      navToVideoView()
    }
  }, [prevIsOnCall, isOnCall, navToVideoView, mediumBp])

  return (
    <WidgetPageContainer videoVariant={false}>
      <WidgetHeaderBar bgVariant />
      <LightboxProvider>
        {appLocation.topicView === TOPIC_VIEW.VIDEO_VIEW ? (
          <Room />
        ) : (
          <>
            {!selectedTopicId && <div className={spacerStyles()} />}
            {!!selectedTopicId && <Timelines />}
            <Composer />
          </>
        )}

        <div id="dropzone" className="dropzone" />
      </LightboxProvider>
    </WidgetPageContainer>
  )
}

const spacerStyles = css({
  flexGrow: 1,
})
